<template>
  <div>
    <ejs-grid ref="gridOfBatchDetail" :dataSource="dataSourceOnBatchDetail">
      <e-columns>
        <e-column field='startTime' :headerText='this.$t("MCS.startTime")' textAlign='Center' width='18%' clipMode='EllipsisWithTooltip' :formatter='startTimeFormatter'></e-column>
        <e-column field='endTime' :headerText='this.$t("MCS.endTime")' textAlign='Center' width='18%' clipMode='EllipsisWithTooltip' :formatter='endTimeFormatter'></e-column>
        <e-column field='process' :headerText='this.$t("MCS.process")' :template='processTemplate' textAlign='Center' width='11%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='step' :headerText='this.$t("MCS.taskStep")' textAlign='Center' width='12%' clipMode='EllipsisWithTooltip' :formatter='stepFormatter'></e-column>
        <e-column field='taskStatus' :headerText='this.$t("MCS.executionResult")' textAlign='Center' width='12%' clipMode='EllipsisWithTooltip' :formatter='taskStatusFormatter'></e-column>
        <e-column field='description' :headerText='this.$t("MCS.resultDetail")' textAlign='Center' width='12%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskStatus' :headerText='this.$t("MCS.downloadResult")' textAlign='Center' width='17%' clipMode='EllipsisWithTooltip' :template='downloadTemplate'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
  import DateUtil from "../../../../pmConfig/util/DateUtil";
  import ProcessBarChain from '../ProcessBarChain';
  import DownloadChain from '../DownloadChain';

  export default {
    name: "BatchDetailDialog",
    data() {
      return {
        dataSourceOnBatchDetail: [],
        step: new Map()
          .set(1, this.$t("MCS.startTask"))
          .set(2, this.$t("MCS.sendingMML"))
          .set(3, this.$t("MCS.recieveMML"))
          .set(4, this.$t("MCS.taskEnd"))
          .set(30, this.$t("MCS.importingUser"))
          .set(31, this.$t("MCS.importingGroup"))
          .set(32, this.$t("MCS.importingGroupMember"))
          .set(33, this.$t("MCS.importingOrgaintion"))
          .set(34, this.$t("MCS.importingResult"))
          .set(35, this.$t("MCS.checkingData"))
          .set(36, this.$t("MCS.waittingResult")),
        taskStatus: new Map()
          .set(0, this.$t("MCS.dataValidationFailed"))
          .set(1, this.$t("MCS.allImportFailed"))
          .set(2, this.$t("MCS.partiallyImportSuccess"))
          .set(3, this.$t("MCS.importSuccess"))
          .set(4, this.$t("MCS.programException"))
          .set(5, this.$t("MCS.excelReadError"))
          .set(6, this.$t("MCS.templateNotFound"))
          .set(7, this.$t("MCS.unzipFailed"))
          .set(8, this.$t("MCS.getResponseFailed"))
          .set(9, this.$t("MCS.organizationError"))
          .set(10,this.$t("MCS.ftpUploadFailed"))
          .set(11,this.$t("MCS.userOverSheet"))
          .set(12,this.$t("MCS.groupOverSheet"))
          .set(13,this.$t("MCS.groupMemOverSheer"))
          .set(0x0000A001,this.$t("MCS.timeOut"))
          .set(0x0000A002,this.$t("MCS.dispatchFail")),
        processTemplate: function(){
          return {
            template: ProcessBarChain
          }
        },
        downloadTemplate: function() {
          return {
            template: DownloadChain
          }
        }
      }
    },
    methods: {
      startTimeFormatter(grids, data) {
        let date = new Date(data.startTime);
        return DateUtil.getDateString(date);
      },

      endTimeFormatter(grids, data) {
        if(data.endTime == null){
          return "—————";
        }
        let date = new Date(data.endTime);
        return DateUtil.getDateString(date);
      },

      stepFormatter(grids, data) {
        return this.step.get(data.step);
      },
      taskStatusFormatter(grids, data) {
        return this.taskStatus.get(data.taskStatus);
      },
    }
  }
</script>
